/**
 * Modul: Apellyasiya müəllimlərinə WhatsApp mesajı qurmaq və açmaq.
 * AssignmentManagement (Apellyasiyalar sekmesi) və StudentResultsPage (Apellyasiyalar tab)
 * ilə eyni məntiq – bir mesajda həmin hocaya təyin edilən bütün apellyasiyalar,
 * neçəsi yoxlanmış, neçəsi qalmış.
 */

export interface ApellyasiyaWhatsAppStats {
  total: number;
  completedCount: number;
  pendingCount: number;
  fenns: string;
  sinifs: string;
  variant?: string;
}

const LINK = 'https://yoxla.istedad21.edu.az';
const SIGNATURE = `*Hörmətlə,*
*İstedad Kursları Qiymətləndirmə və Layihələrlə İş Mərkəzi*`;

/**
 * Müəllim üçün apellyasiya WhatsApp mətnini qurur.
 * İstifadə: AssignmentManagement və StudentResultsPage.
 */
export function buildApellyasiyaWhatsAppMessage(
  teacherName: string,
  stats: ApellyasiyaWhatsAppStats
): string {
  const { total, completedCount, pendingCount, fenns, sinifs, variant } = stats;
  const fennsLine = fenns || '—';
  const sinifsLine = sinifs || '—';

  let statusBlock = '';
  if (total > 0) {
    if (pendingCount === 0) {
      statusBlock = `✅ *Yoxlanmış:* ${completedCount}/${total} (hamısı tamamlanıb)`;
    } else if (completedCount === 0) {
      statusBlock = `⏳ *Qalmış:* ${pendingCount}/${total} (heç biri hələ yoxlanmayıb)`;
    } else {
      statusBlock = `✅ Yoxlanmış: *${completedCount}* | ⏳ Qalmış: *${pendingCount}* (ümumi ${total})`;
    }
  }

  const variantLine = variant ? `\n📝 Variant: ${variant}` : '';

  return `Hörmətli ${teacherName},

Sizə təyin edilən apellyasiya məlumatı.

📊 Apellyasiya sayı: ${total}
📚 Fənn: ${fennsLine}
🎓 Sinif: ${sinifsLine}${variantLine}
${statusBlock ? `\n${statusBlock}` : ''}

Zəhmət olmasa daxil olub yoxlayın:
${LINK}

${SIGNATURE}`;
}

/**
 * Telefon nömrəsi ilə WhatsApp-da mesajı açar (yeni sekme).
 */
export function openWhatsAppWithMessage(phoneNumber: string, message: string): void {
  const digits = phoneNumber.replace(/[^0-9]/g, '');
  if (!digits) return;
  const encoded = encodeURIComponent(message);
  const url = `https://wa.me/${digits}?text=${encoded}`;
  window.open(url, '_blank');
}
